<form #formConsultar="ngForm">
    <div fxLayout="column" fxFlexFill style="margin: 10px 0;">
        <div fxFlex="100%" fxLayout="row" fxLayoutGap="20px" class="espaco" fxFlexFill>
            <mat-form-field fxFlex="15%">
                <input matInput name="dataInicio"
                       [matDatepicker]="dataInicio"
                       placeholder="Data de Início"
                       required
                       (input)="onMascaraDataInput($event)"
                       [(ngModel)]="acaoPlanejamentoOficina.dataInicio">
                <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                <mat-datepicker #dataInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="15%">
                <input matInput name="dataFim"
                       [matDatepicker]="dataFim"
                       placeholder="Data de Fim"
                       required
                       (input)="onMascaraDataInput($event)"
                       [(ngModel)]="acaoPlanejamentoOficina.dataFim">
                <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                <mat-datepicker #dataFim></mat-datepicker>
            </mat-form-field>


            <mat-form-field fxFlex="15%">
                <mat-label>Local Execução</mat-label>
                <mat-select [(ngModel)]="acaoPlanejamentoOficina.localExecucao" name="localExecucao">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let m of listaLocalExecucao" [value]="m.flag">
                        {{ m.tipo }}
                    </mat-option>
                </mat-select>
            </mat-form-field>           

        </div>
        <div fxLayout="row" fxLayoutGap="5%" style="margin-bottom: 20px">

            <mat-form-field class="topo" style="margin-left: 20px" fxFlex="100%" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea matInput #message name="descricao" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3" maxlength="4000" [(ngModel)]="acaoPlanejamentoOficina.descricao">
                     </textarea>
                <mat-hint align="end">{{message.value.length}} / 4000</mat-hint>
            </mat-form-field>
        
        </div>
    </div>
    <mat-tab-group>
        <mat-tab label="METAS">
            <div ngModelGroup="grupoAcoesMetas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <div *ngFor="let meta of acaoPlanejamentoOficina.metas; let index = index">
                        <formulario-acoes-metas [meta]="meta"
                                                [index]="index"
                                                [metas]="acaoPlanejamentoOficina.metas"
                                                [perfilAcesso]="perfilAcesso"
                                                [acoes]="planejamentoOficina.acoesPlanejamentoOficina.concat(acaoPlanejamentoOficina)">
                        </formulario-acoes-metas>
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                         style="padding-top: 10px; padding-left: 20px;">
                        <div>
                            <button matTooltip="Nova Meta" mat-mini-fab color="primary" (click)="addMeta()"
                                    style="width: 140px;border-radius: 5px;">
                                <mat-icon>add</mat-icon>
                                Meta
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</form>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>


    <button *ngIf="!isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary"
            (click)="zerarCombos()">
        Limpar
    </button>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="adicionar()">
        Adicionar Ação
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
        Cancelar
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="atualizar()">
        Atualizar Ação
    </button>


</div>
